// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"962":"3fe3e593","982":"d389fb8e"}[chunkId] + ".chunk.css";
};